import { isAxiosError } from '~/helpers/error';

/** Mensagem devolvida pelo backend num erro de requisição (ex.: o DAM não confirmou o comando). */
export function getApiErrorDetail(error: unknown): string | null {
  if (!(error instanceof Error) || !isAxiosError(error)) return null;
  const data = error.response?.data;
  return typeof data === 'string' && data ? data : null;
}
